import { belowBreakpoint, Box, Text, Theme, useMediaQuery } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { addWeeks, getISOWeek, isAfter, parseISO } from 'date-fns';
import { find, times } from 'lodash';
import { FC, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { TabButtonStyled, TabListStyled } from './styled';
import { TabFilterProps } from './types';

export const TabFilters: FC<TabFilterProps> = ({ user, tabFilterValues, onTabFilterChange }) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  const currentProjectWeek = find(user?.project?.projectConfiguration?.projectWeeks, (projectWeek) =>
    projectWeek?.isCurrent ? true : false
  );
  const currentWeekStartDate = parseISO(currentProjectWeek?.startDate); //parseIso is required since weekStartDate is date(NOT datetime) string
  const currentWeekEndDate = parseISO(currentProjectWeek?.endDate);
  const selectedWeekStartDate = tabFilterValues?.weekStartDay
    ? new Date(tabFilterValues?.weekStartDay)
    : currentWeekStartDate;
  const selectedWeekEndDate = tabFilterValues?.weekEndDay ? new Date(tabFilterValues?.weekEndDay) : currentWeekEndDate;
  const claimedFilter = tabFilterValues?.milestoneStatus === MilestoneStatusCode.CLAIMED ? true : false;
  const selectedWeek = getISOWeek(selectedWeekStartDate);

  return (
    <>
      <TabListStyled>
        {times(4, (index) => {
          const weekStartDate = addWeeks(currentWeekStartDate, index - 1);
          const weekEndDate = addWeeks(currentWeekEndDate, index - 1);
          const weekNumber = getISOWeek(weekStartDate);

          return (
            <TabButtonStyled
              selected={selectedWeek === weekNumber}
              key={index}
              onClick={() => {
                onTabFilterChange({
                  weekEndDay: weekEndDate,
                  weekStartDay: weekStartDate,
                  milestoneStatus: MilestoneStatusCode.PLANNED,
                });
              }}
            >
              <Box flexDirection={{ sm: 'column' }}>
                <Text size={isWideScreen ? '200' : '300'} color="blue.700">
                  <Trans>Week</Trans>
                </Text>
                <Text size={isWideScreen ? '500' : '600'} color="blue.700">
                  {weekNumber || 0}
                </Text>
              </Box>
            </TabButtonStyled>
          );
        })}
      </TabListStyled>
      <TabListStyled>
        <TabButtonStyled
          selected={!claimedFilter}
          onClick={() => {
            onTabFilterChange({
              weekEndDay: selectedWeekEndDate,
              weekStartDay: selectedWeekStartDate,
              milestoneStatus: MilestoneStatusCode.PLANNED,
            });
          }}
        >
          <Box flexDirection={{ sm: 'column' }}>
            <Text size="400" color="grey.1000">
              <Trans>Unclaimed</Trans>
            </Text>
          </Box>
        </TabButtonStyled>
        <TabButtonStyled
          selected={claimedFilter}
          onClick={() => {
            onTabFilterChange({
              weekEndDay: selectedWeekEndDate,
              weekStartDay: selectedWeekStartDate,
              milestoneStatus: MilestoneStatusCode.CLAIMED,
            });
          }}
          disabled={isAfter(selectedWeekStartDate, currentWeekStartDate)}
        >
          <Box flexDirection={{ sm: 'column' }}>
            <Text size="400" color="grey.1000">
              <Trans>Claimed</Trans>
            </Text>
          </Box>
        </TabButtonStyled>
      </TabListStyled>
    </>
  );
};
